import React from "react";
import { ProgressBar, Spinner } from "react-bootstrap";
import "./loader.css";

const transparentLoader = {
  opacity:"0.5",
  zIndex: "9999999" 
};

export const RoundLoader = ({ externalClass = "" }) => {
  return (
    <div
      className={"spinner-wrap " + externalClass}
      style={{ zIndex: "9999999" }}
    >
      <div className={"spinner-inner"} style={transparentLoader}>
        <Spinner animation="border" variant="warning" />
      </div>
    </div>
  );
};

/** EQUP COLOR LOADER **/
const RoundLoaderWithOverlay = ({ externalClass = "" }) => {
  return (
    <div
      className={"spinner-wrap " + externalClass}
     style={transparentLoader}
    >
      <img
        src={require("../../../Assets/Images/saleoid-loader.gif")}
        height="60"
        width="60"
      />
    </div>
  );
};

export const EqupRoundLoaderWithOverlay = ({ externalClass = "" }) => {
  return (
    <div
      className={"spinner-wrap " + externalClass}
      style={{ zIndex: "9999999" }}
    >
      <img
        src={require("../../../Assets/Images/saleoid-loader.gif")}
        height="60"
        width="60"
      />
    </div>
  );
};

export const EqupRoundLoaderWithoutOverlay = ({ externalClass = "" }) => {
  return (
    <div className={"spinner-wrap " + externalClass} style={transparentLoader}>
      <img
        src={require("../../../Assets/Images/saleoid-loader.gif")}
        height="60"
        width="60"
      />
    </div>
  );
};

export const EqupProgressBarWithOverlay = ({
  externalClass = "",
  now = 0,
  message = "",
}) => {
  return (
    <div
      className={"spinner-wrap " + externalClass}
      style={{ zIndex: "9999999" }}
    >
      <div className={"equp-progress"}>
        <ProgressBar animated now={now} label={`${parseInt(now)}%`} />
        <p className="text-center small text-primary mt-2">{message}</p>
      </div>
    </div>
  );
};

export default RoundLoaderWithOverlay;
